import React from 'react';
import {
  Box,
  Button,
  CircularProgress,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from '@mui/material';

import { StyledDialog } from 'theme/index';

interface ApproveDialogProps {
  open: boolean;
  documentName?: string;
  loading?: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

const ApproveDialog: React.FC<ApproveDialogProps> = ({
  open,
  documentName,
  loading = false,
  onClose,
  onConfirm,
}) => (
  <StyledDialog open={open} onClose={loading ? undefined : onClose} maxWidth='sm' fullWidth>
    <DialogTitle sx={{ fontWeight: 600 }}>Approve Document</DialogTitle>
    <DialogContent sx={{ flex: '0 0 auto' }}>
      <Box
        sx={{
          display: 'grid',
          placeItems: 'center',
          width: '100%',
          textAlign: 'center',
          py: 1,
        }}
      >
        <Typography variant='body1' sx={{ fontSize: '18px' }} color='text.primary'>
          Are you sure you want to approve this document?
        </Typography>
      </Box>
    </DialogContent>
    <DialogActions
      sx={{
        px: 3,
        pb: 2,
        justifyContent: 'center',
        gap: 1,
        position: 'relative',
        zIndex: 1,
      }}
    >
      <Button
        type='button'
        variant='outlined'
        onClick={onClose}
        disabled={loading}
      >
        Cancel
      </Button>
      <Button
        type='button'
        variant='contained'
        color='success'
        onClick={onConfirm}
        disabled={loading}
        startIcon={loading ? <CircularProgress size={18} color='inherit' /> : undefined}
      >
        Approve
      </Button>
    </DialogActions>
  </StyledDialog>
);

export default ApproveDialog;
